import PropTypes from 'prop-types'

const propTypes = {
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.element]),
    className: PropTypes.string,
    icon: PropTypes.element,
    iconSize: PropTypes.number,
    text: PropTypes.string
}

export default propTypes
